import React, { useState } from 'react'

// styles
import {
    HeaderStylesContainer,
    PromotionStylesContainer,
    NavStylesContainer
} from './styles/HeaderStyles'

// header components
import HeaderContent from './includes/HeaderContent'
import MenuContent from './includes/MenuContent'

export default function Header(props) {
    // props
    const {
        categories
    } = props

    // states
    const [mobileMenuVisibility, setMobileMenuVisibility] = useState(false)

    return (
        <header>
            {/* PROMOTION */}
            <PromotionStylesContainer>
                <div className="container">
                    <div className="main-sec">
                        <p className="text-center st-fs-14 st-fw-700 mb-0">
                            SITEWIDE FREE SHIPPING | NO MINIMUM | ORDER PROCESSING TIME 5 -
                            7 BUSINESS DAYS
                        </p>
                    </div>
                </div>
            </PromotionStylesContainer>

            {/* HEADER */}
            <HeaderStylesContainer>
                <div className="container">
                    <HeaderContent
                        setMobileMenuVisibility={setMobileMenuVisibility}
                    />
                </div>
            </HeaderStylesContainer>

            {/* MENU */}
            <NavStylesContainer>
                <div className="container">
                    <MenuContent
                        categories={categories}

                        mobileMenuVisibility={mobileMenuVisibility}
                        setMobileMenuVisibility={setMobileMenuVisibility}
                    />
                </div>
            </NavStylesContainer>
        </header>
    )
}
